import SvgLoader from 'src/components/Common/SvgLoader';
import { IconCardProps } from '../types';

const IconCard = ({ header, handleClick, imgSrc, wrapClasses = '' }: IconCardProps) => {
  return (
    <li className={`p-12 sm:p-16 sm:w-1/2 md:w-1/3 lg:w-1/4 ${wrapClasses}`}>
      <div className="relative flex sm:flex-col sm:h-full">
        <img
          className="icon-80 sm:icon-128 mr-12 sm:mx-auto sm:mb-12 rounded-full bg-transparent"
          src={imgSrc}
          alt=""
          width="128"
          height="128"
          loading="lazy"
          aria-hidden="true"
        />
        <button
          className="flex flex-col flex-grow justify-center sm:justify-start text-left sm:text-center link-block no-underline hover:underline"
          onClick={handleClick}
        >
          <p className="text-xl w-full">
            {header}
            <span className="whitespace-nowrap">
              &zwnj;
              <SvgLoader
                className="inline-flex ml-6"
                color="text-white"
                size={13}
                name="Arrow"
                aria-hidden="true"
              />
            </span>
          </p>
        </button>
      </div>
    </li>
  );
};

const IconCards = ({ cards }: { cards: Array<Omit<IconCardProps, 'wrapClasses'>> }) => {
  const totalCards = cards.length;

  if (!totalCards) {
    return null;
  }

  return (
    <div className="container-4xl">
      <ul className="sm:flex sm:flex-wrap sm:justify-center -m-12 sm:-m-16 py-36">
        {cards.map((card, i) => {
          let wrapClasses = '';

          if (totalCards === 4 && i === 0) {
            wrapClasses = 'md:ml-px lg:ml-0';
          }

          if ((totalCards === 5 || totalCards === 6 || totalCards === 9) && (i === 0 || i === 3)) {
            wrapClasses = 'lg:ml-px';
          }

          return <IconCard key={`cards${i}`} {...{ ...card, wrapClasses }} />;
        })}
      </ul>
    </div>
  );
};

export { IconCard };
export default IconCards;
